import React from 'react';
import { View, Text } from 'react-native';
import * as Store from 'modules/index';
import { connect } from 'react-redux';
import Loader from 'components/Loader';
import * as FFObject from 'model/FFObject';
import * as API from 'generated/api';
import * as Cache from 'modules/Cache';
import * as AsyncValue from 'utility/AsyncValue';
import { flattenRecord } from 'utility/AsyncValue';

interface Props {
  chatKey: string;
  children: (cache: [API.FFPublicChat, Record<string, FFObject.FFObject>]) => JSX.Element;
}

const mapStateToProps = (state: Store.State) => ({
  _getCachedChatByURLKey: (key: string): AsyncValue.AsyncValue<API.FFPublicChat> => {
      return state.cache.chats[key] ?? AsyncValue.fetching();
  },
  _objects: flattenRecord(state.cache.objects),
});

const mapDispatchToProps = {
  load: (key: string) => Cache.syncChatWithURLKey({ urlKey: key }),
};

function mergeProps(
  { _getCachedChatByURLKey, _objects, ...stateProps }: ReturnType<typeof mapStateToProps>,
  dispatchProps: typeof mapDispatchToProps,
  ownProps: Props,
) {
  const chat = _getCachedChatByURLKey(ownProps.chatKey);
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    loadKey: ownProps.chatKey,
    value: chat,
    children: (chat: any) => ownProps.children([chat, _objects]),
    errored: () => (
      <View
        style={{
          width: '100%',
          height: '100vh', // DOM-only
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
      <iframe
        title="Chat not found"
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
        }}
        src={`${process.env.REACT_APP_WEBSITE_HOST}/chat-not-found`}
      />
      </View>
    ),
    loading: () => (
      <View
        style={{
          width: '100%',
          height: '100vh', // DOM-only
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Text style={{color: 'black'}}>
          loading...
        </Text>
      </View>
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Loader);
